var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "welcome-modal-header-block" }, [
      _c("p", { staticClass: "welcome-modal-header welcome-modal-header-sm" }, [
        _vm._v(
          "\n            " +
            _vm._s(_vm.$resourceString["virtualtray.welcomemodal.header"]) +
            "\n          "
        )
      ]),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "welcome-modal-subheader welcome-modal-subheader-sm" },
        [
          _vm._v(
            "\n            " +
              _vm._s(
                _vm.$resourceString["virtualtray.welcomemodal.subheader"]
              ) +
              "\n          "
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "welcome-modal-body" }, [
      _c("div", { staticClass: "welcome-modal-step welcome-modal-step-sm" }, [
        _c("div", { staticClass: "welcome-modal-step-header" }, [
          _c("b", [
            _vm._v(
              _vm._s(_vm.$resourceString["virtualtray.welcomemodal.step1"])
            )
          ]),
          _vm._v(
            "\n              " +
              _vm._s(
                _vm.$resourceString["virtualtray.welcomemodal.step1.header"]
              ) +
              "\n            "
          )
        ]),
        _vm._v(
          "\n            " +
            _vm._s(
              _vm.$resourceString["virtualtray.welcomemodal.step1.description"]
            ) +
            "\n          "
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "welcome-modal-step welcome-modal-step-sm " }, [
      _c("div", { staticClass: "welcome-modal-step-header" }, [
        _c("b", [
          _vm._v(_vm._s(_vm.$resourceString["virtualtray.welcomemodal.step2"]))
        ]),
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.$resourceString["virtualtray.welcomemodal.step2.header"]
            ) +
            "\n      "
        )
      ]),
      _vm._v(
        "\n      " +
          _vm._s(
            _vm.$resourceString["virtualtray.welcomemodal.step2.description"]
          ) +
          "\n    "
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }